export async function loadCatalog (locale) {
    const catalog = await import(`@lingui/loader!../translations/locales/${locale}/messages.po`)
    return catalog.messages
}
